export default "__VITE_ASSET__CtTYWpmr__"